import type {Component} from 'typings/portaro.fe.types';
import type SdiRequestsDataService from '../../data-services/sdi-requests.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {remove} from 'shared/utils/array-utils.fp';
import type CurrentAuthService from '../../services/current-auth.service';
import type {SdiRequest, SdiSending} from 'typings/portaro.be.types';

export class KpSdiRequestListItemComponentController implements KpSdiRequestListItemComponentBindings {
    public request: SdiRequest;
    public requests: SdiRequest[];
    public showUser: boolean;
    public sendings: SdiSending[];
    public isSendingsVisible = false;

    /*@ngInject*/
    constructor(private sdiRequestsDataService: SdiRequestsDataService, private currentAuthService: CurrentAuthService) {}

    public async toggleSdiRequestActive() {
        this.request.active = !this.request.active;
        await this.sdiRequestsDataService.editSdiRequest(this.request);
    }

    public async removeSdiRequest() {
        await this.sdiRequestsDataService.removeSdiRequest(this.request.id);
        remove(this.request)(this.requests);
    }

    @ngAsync()
    public async loadSendings(request: SdiRequest) {
        this.sendings = await this.sdiRequestsDataService.querySendings(request.id);
    }

    public showSendings() {
        this.isSendingsVisible = !this.isSendingsVisible;

        // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
        this.isSendingsVisible && this.loadSendings(this.request);
    }
}

export default class KpSdiRequestListItemComponent implements Component<KpSdiRequestListItemComponentBindings> {
    public static componentName = 'kpSdiRequestListItem';

    public templateUrl = require('./kp-sdi-request-list-item.tpl.ftl');

    public bindings = {
        request: '<',
        requests: '<',
        showUser: '<'
    } as const;

    public controller = KpSdiRequestListItemComponentController;
}

interface KpSdiRequestListItemComponentBindings {
    request: SdiRequest;
    requests: SdiRequest[];
    showUser: boolean;
}
